<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="zoneDeStockageSvc"></yo-generic-datagrid-pn>
